<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";
import ppProgramAPI from "@/services/standards/promotionPrevention/ppProgramAPI";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import Swal from "sweetalert2";

const DEF_OBJ = "Promover estilos de trabajo y de vida saludables, prevenir accidentes de trabajo y enfermedades laborales, fortalecer la cultura del autocuidado y garantizar condiciones seguras y saludables para todos los trabajadores, mediante la implementación de actividades de promoción y prevención en el marco del SG-SST.";
const DEF_ESP = "• Promover hábitos y estilos de vida saludables.\n• Identificar y controlar factores de riesgo en los lugares de trabajo.\n• Reducir la ocurrencia de accidentes de trabajo e incidentes.\n• Prevenir enfermedades laborales mediante vigilancia epidemiológica.\n• Fortalecer la participación de los trabajadores en el SG-SST.\n• Desarrollar campañas permanentes de promoción de la salud y prevención de riesgos.\n• Evaluar periódicamente la efectividad de las actividades implementadas.";
const DEF_ALC = "Aplica para todos los trabajadores, contratistas, practicantes, aprendices y demás personas que desarrollen actividades en las instalaciones de la organización o en representación de esta.";

export default {
  page: { title: "Programa de Promoción y Prevención" },
  components: { Layout, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      title: "7.1.1 Programa de Promoción y Prevención",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        { text: "7.1.1 Promoción y Prevención", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      programId: this.$route.params.program || null,
      form: {
        version: "1.0", approval_date: new Date().toISOString().substring(0, 10),
        change_description: "Emisión inicial del programa.", responsable: null,
        objetivo_general: DEF_OBJ, objetivos_especificos: DEF_ESP, alcance: DEF_ALC, observacion: null,
      },
      workflowStatus: "draft", signedAt: null, submitting: false, loading: true,
    };
  },
  computed: {
    isSigned() { return this.workflowStatus === "signed"; },
    programApi() {
      return {
        pdfUrl: (id) => ppProgramAPI.pdfUrl(id),
        sign: (id, payload) => ppProgramAPI.sign(id, payload),
      };
    },
  },
  methods: {
    goBack() { this.$router.go(-1); },
    load() {
      if (!this.programId) { this.loading = false; return; }
      ppProgramAPI.get(this.programId)
        .then((r) => {
          if (!r) { this.loading = false; return; }
          this.form.version = r.version || "1.0";
          this.form.approval_date = r.approval_date ? String(r.approval_date).substring(0, 10) : this.form.approval_date;
          this.form.change_description = r.change_description || null;
          this.form.responsable = r.responsable || null;
          this.form.objetivo_general = r.objetivo_general || DEF_OBJ;
          this.form.objetivos_especificos = r.objetivos_especificos || DEF_ESP;
          this.form.alcance = r.alcance || DEF_ALC;
          this.form.observacion = r.observacion || null;
          this.workflowStatus = r.workflow_status || "draft";
          this.signedAt = r.signed_at || null;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    save() {
      if (this.isSigned) return;
      this.submitting = true;
      const payload = { companies_id: this.companyID, ...this.form };
      const req = this.programId ? ppProgramAPI.update(this.programId, payload) : ppProgramAPI.save(payload);
      req
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 57, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Programa guardado.", icon: "success", timer: 1600, showConfirmButton: false });
          this.submitting = false;
          if (!this.programId && res && res.id) {
            this.programId = res.id;
            this.$router.replace({ path: `/forms/estandares/${this.companyID}/pp-programa/${res.id}` });
            this.load();
          }
        })
        .catch((e) => { console.log(e); this.submitting = false; Swal.fire("Error", "No se pudo guardar el programa", "error"); });
    },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() { this.load(); },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-9" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <CheckModal>
              <p class="text-justify">
                Documento estructurado del Programa de Promoción y Prevención. El marco normativo, las
                responsabilidades, las actividades de promoción y prevención, los recursos y los indicadores son texto
                fijo; aquí editas la identificación de la versión y las secciones de objetivo general, objetivos
                específicos y alcance. Cada guardado es una versión que puede firmarse.
              </p>
            </CheckModal>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 Esta versión ya fue firmada; los datos quedan bloqueados. Crea una "Nueva versión" desde el hub.
            </div>

            <form @submit.prevent="save">
              <div class="form-row">
                <b-form-group class="col-md-2 px-2" label="Versión"><b-form-input type="text" v-model="form.version" :disabled="isSigned" /></b-form-group>
                <b-form-group class="col-md-3 px-2" label="Fecha de aprobación"><b-form-input type="date" v-model="form.approval_date" :disabled="isSigned" required /></b-form-group>
                <b-form-group class="col-md-3 px-2" label="Responsable"><b-form-input type="text" v-model="form.responsable" :disabled="isSigned" /></b-form-group>
                <b-form-group class="col-md-4 px-2" label="Descripción del cambio"><b-form-input type="text" v-model="form.change_description" :disabled="isSigned" /></b-form-group>
              </div>

              <b-form-group label="1. Objetivo general"><b-form-textarea v-model="form.objetivo_general" :disabled="isSigned" rows="3" max-rows="8" /></b-form-group>
              <b-form-group label="2. Objetivos específicos (una línea por objetivo)"><b-form-textarea v-model="form.objetivos_especificos" :disabled="isSigned" rows="6" max-rows="14" /></b-form-group>
              <b-form-group label="3. Alcance"><b-form-textarea v-model="form.alcance" :disabled="isSigned" rows="2" max-rows="6" /></b-form-group>
              <b-form-group label="Observaciones (opcional)"><b-form-input type="text" v-model="form.observacion" :disabled="isSigned" /></b-form-group>

              <p class="text-muted small">
                Secciones fijas en el PDF: marco normativo, responsabilidades, actividades de promoción, actividades de
                prevención, cronograma/recursos e indicadores.
              </p>

              <div class="text-right">
                <button type="submit" :disabled="isSigned || submitting" class="btn btn-primary mx-1">Guardar</button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-3" v-if="!loading && programId">
        <h6 class="text-muted small mb-1">Programa de P&amp;P</h6>
        <DocumentActions
          :document-id="Number(programId)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="programApi"
          document-title="Programa de Promoción y Prevención"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
    </div>
  </Layout>
</template>
